@if (eventGuid) {
<div class="materials-event">
  @if (moduleDisabled) {
  <p class="empty-message">
    Materielmodulet er ikke aktiveret for denne organisation.
  </p>
  } @else if (!showMaterialsSection) {
  } @else {
  <div class="card-header">
    <h3 class="section-title">Materialanmodninger</h3>
    <p class="section-desc">
      Anmod om materialer til dette event og se status.
      @if (eventWindow) {
      <span class="window-hint">
        Ledighed beregnes for perioden
        {{ eventWindow.from | date : "shortDate" }} –
        {{ eventWindow.to | date : "shortDate" }}
        @if (bufferDays > 0) { (inkl. {{ bufferDays }} dages buffer) }
      </span>
      }
    </p>
  </div>
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  }
  <div class="toolbar">
    <button
      mat-raised-button
      color="primary"
      (click)="openAddRequest()"
      [disabled]="showAddRequest || loading || availableMaterials.length === 0"
    >
      + Tilføj anmodning
    </button>
    <button mat-button (click)="load()" [disabled]="loading">
      {{ loading ? "Henter..." : "Opdater liste" }}
    </button>
  </div>
  @if (!loading && availableMaterials.length === 0 && eventGuid) {
  <p class="toolbar-hint">
    Ingen materialer i listen. Opret materialer under Materialer-oversigten og
    klik "Opdater liste" her.
  </p>
  } @if (showAddRequest) {
  <div class="form-block">
    <h5>Ny materialanmodning</h5>
    @if (getMaterialsNotYetRequested().length === 0) {
    <p class="form-hint">
      Alle materialer er allerede anmodet om for dette event.
    </p>
    } @if (getMaterialsNotYetRequested().length) {
    <mat-form-field appearance="outline">
      <mat-label>Materiale</mat-label>
      <mat-select
        [(ngModel)]="addForm.material_id"
        (ngModelChange)="addForm.location_id = 0"
      >
        @for (a of getMaterialsNotYetRequested(); track a.material_id) {
        <mat-option [value]="a.material_id">
          {{ a.name }}
          @if (trackStock) {
          (ledigt: {{ a.remaining_for_event }} / {{ a.total_quantity }})
          }
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (multiLocation && getSelectedMaterial(); as sel) {
      @if (locationOptionsForMaterial(sel).length > 0) {
    <mat-form-field appearance="outline">
      <mat-label>Lagerlokation</mat-label>
      <mat-select [(ngModel)]="addForm.location_id">
        <mat-option [value]="0">Ikke angivet / samlet</mat-option>
        @for (loc of locationOptionsForMaterial(sel); track loc.location_id) {
        <mat-option [value]="loc.location_id">
          {{ loc.name }} (ledigt: {{ loc.remaining }})
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
      }
    }
    }
    <mat-form-field appearance="outline">
      <mat-label>Antal</mat-label>
      <input
        matInput
        type="number"
        min="1"
        [max]="maxQuantityForAdd()"
        [(ngModel)]="addForm.quantity"
      />
    </mat-form-field>
    @if (trackStock) {
    <p class="form-hint">Maks. {{ maxQuantityForAdd() }} i perioden.</p>
    }
    <mat-form-field appearance="outline" class="notes-field">
      <mat-label>Note (valgfri)</mat-label>
      <input
        matInput
        [(ngModel)]="addForm.instructor_notes"
        placeholder="F.eks. ønsket afhentningstid"
      />
    </mat-form-field>
    <div class="form-actions">
      <button type="button" mat-button (click)="cancelAddRequest()">
        Annuller
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        [disabled]="saving"
        (click)="saveAddRequest()"
      >
        {{ saving ? "Gemmer..." : "Opret anmodning" }}
      </button>
    </div>
  </div>
  } @if (loading) {
  <p class="loading-message">Henter materialer...</p>
  } @if (!loading && materials.length) {
  <table class="materials-table">
    <thead>
      <tr>
        <th>Materiale</th>
        <th>Antal</th>
        <th>Status</th>
        <th>Din note</th>
        <th>Admin note</th>
      </tr>
    </thead>
    <tbody>
      @for (m of materials; track m.event_material_id) {
      <tr>
        <td>{{ m.name }}</td>
        <td>
          @if (m.status === 'pending') {
          <input
            type="number"
            min="1"
            [value]="m.quantity"
            (change)="
              updateQuantity(m.event_material_id, +$any($event.target).value)
            "
            class="qty-input"
          />
          } @if (m.status !== 'pending') {
          <span>{{ m.quantity }}</span>
          }
        </td>
        <td>{{ statusLabel(m.status) }}</td>
        <td class="notes-cell">
          @if (m.status === 'pending') {
          <input
            type="text"
            [(ngModel)]="editingNotes[m.event_material_id]"
            (blur)="
              saveInstructorNotes(
                m.event_material_id,
                editingNotes[m.event_material_id] || ''
              )
            "
            placeholder="Tilføj note"
          />
          } @if (m.status !== 'pending') {
          <span>{{ m.instructor_notes || "-" }}</span>
          }
        </td>
        <td class="notes-cell">{{ m.admin_notes || "-" }}</td>
      </tr>
      }
    </tbody>
  </table>
  } @if (!loading && materials.length === 0 && !showAddRequest) {
  <p class="empty-message">
    Ingen materialanmodninger for dette event. Klik på "Tilføj anmodning" for at
    anmode om materialer.
  </p>
  }
  }
</div>
} @if (!eventGuid) {
<div class="no-event">
  <p>Ingen event valgt. Åbn et event for at se materialanmodninger.</p>
</div>
}
